import React, { ReactNode } from 'react';
import { Icon } from '@phosphor-icons/react';

interface SettingsLineProps {
  label: string;
  children: ReactNode;
  icon?: Icon;
  isLast?: boolean;
}

export function SettingsLine({ label, children, icon: IconComponent, isLast = false }: SettingsLineProps) {
  return (
    <div className={`flex items-center justify-between py-4 ${!isLast ? 'border-b border-gray-200' : ''}`}>
      <div className="flex items-center space-x-2">
        {IconComponent && <IconComponent className="w-5 h-5 text-[#361e06]" weight="bold" />}
        <div className="font-medium text-[#361e06]">{label}</div>
      </div>
      <div className="flex items-center">{children}</div>
    </div>
  );
} 